import { render, staticRenderFns } from "./HrDocumentSettingsDialog.vue?vue&type=template&id=66bcf815&scoped=true&"
import script from "./HrDocumentSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./HrDocumentSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./HrDocumentSettingsDialog.vue?vue&type=style&index=0&id=66bcf815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bcf815",
  null
  
)

export default component.exports